import type { IErrorObjectProps } from './types';

const defaultErrorCodes: Record<number, IErrorObjectProps> = {
  404: {
    statusCode: 404,
    title: 'Seite nicht gefunden / Page not found',
    message: '<p>Die von Ihnen aufgerufene Seite wurde nicht gefunden.</p><p>The page you requested was not found.</p>',
  },
  500: {
    statusCode: 500,
    title: 'Unerwarteter Fehler / Unexpected error',
    message: '<p>Ein unerwarteter Fehler ist aufgetreten. Bitte versuchen Sie es später erneut.</p><p>An unexpected error occurred. Please try again later.</p>',
  },
  503: {
    statusCode: 503,
    title: 'Server nicht erreichbar / Server unavailable',
    message: '<p>Der Server ist nicht erreichbar. Bitte versuchen Sie es später erneut.</p><p>The server is unavailable. Please try again later.</p>',
  },
};

export const getErrorFragments = (error: IErrorObjectProps) => {
  if (typeof error.title === 'string' && typeof error.message === 'string') {
    return error;
  }

  const useCode = defaultErrorCodes[error.statusCode] ? error.statusCode : 500;
  return defaultErrorCodes[useCode];
};

export const wrapMessage = (message: string) => {
  if (message.substring(0, 1) === '<' && message.substring(message.length - 1) === '>') {
    return message;
  }
  return `<p>${message}</p>`;
};
